module.exports = __webpack_public_path__ + "static/media/05_NSV106AMS.5962a80f.png";